<my-content placeholder="navigation">
  <!-- modal-Module-Start -->
  <div id="ModalPopUP" class="modal fade" data-backdrop="static" data-keyboard="false" role="dialog">
    <div class="modal-dialog-FactSheet">
      <div class="modal-content">
        <div class="modal-header BlueHeader">
          <h4 class="Heading">{{ ModelFor }}</h4>
          <br />
          <button type="button" class="close" data-dismiss="modal">
            &times;
          </button>
        </div>
        <div class="modal-body col-sm-12 form-group" style="overflow-y: auto; height: 500px; padding: 0px">
          <div *ngIf="this.MsgType == 2">
            <div *ngFor="let flow of FlowData" class="form-control col-sm-12">
              <a routerLink="/{{ ReportUrl }}{{ flow.SubDescr }}/0" target="_blank">
                <span style="color: #337ab7">{{ flow.MainDescr }}, Decision</span>
              </a>
            </div>
          </div>
          <div *ngIf="this.MsgType == 7">
            <div *ngFor="let flow of FlowData" class="form-control col-sm-12">
              <a routerLink="/{{ ReportUrl }}{{ flow.SubDescr }}/0" target="_blank">
                <span style="color: #337ab7">{{ flow.MainDescr }}, Library</span>
              </a>
            </div>
          </div>
          <div *ngIf="this.MsgType == 3">
            <div class="col-sm-4"></div>
            <div class="form-control col-sm-4">
              <label class="radio-inline"><input type="radio" Name="NoticeSent" (click)="onItemChange('1')" value="1"
                  checked />Sent</label>
              <label class="radio-inline"><input type="radio" Name="NoticeSent" (click)="onItemChange('0')"
                  value="0" />Received</label>
              <label class="radio-inline"><input type="radio" Name="NoticeSent" (click)="onItemChange('2')"
                  value="2" />All</label>
            </div>
            <div class="col-sm-4"></div>
            <div *ngFor="let flow of FlowData" class="form-control col-sm-12">
              <a routerLink="/{{ ReportUrl }}{{ flow.SubDescr }}/HLPNoticeType~{{
                  RadioValue
                }}" target="_blank">
                <span style="color: #337ab7">{{ flow.MainDescr }}, Notice</span>
              </a>
            </div>
          </div>
          <div *ngIf="this.MsgType == 4">
            <div class="col-sm-4"></div>
            <div class="form-control col-sm-12">
              <label class="radio-inline"><input type="radio" Name="CaseSent" (click)="onItemChange('1')" value="1"
                  checked />Filed By Us</label>
              <label class="radio-inline"><input type="radio" Name="CaseSent" (click)="onItemChange('0')"
                  value="0" />Against Us</label>
              <label class="radio-inline"><input type="radio" Name="CaseSent" (click)="onItemChange('2')"
                  value="2" />All</label>
              <!-- <label class="radio-inline"><input type="radio" Name="CaseSent" (click)="onItemChange('3')"
                                        value="2">E-Court</label> -->
            </div>
            <div class="col-sm-4"></div>
            <div *ngFor="let flow of FlowData" class="form-control col-sm-12">
              <a routerLink="/{{ ReportUrl }}{{ flow.SubDescr }}/HLPNoticeType~{{
                  RadioValue
                }}" target="_blank">
                <span style="color: #337ab7">{{ flow.MainDescr }}, Case</span>
              </a>
            </div>
          </div>
          <div *ngIf="this.MsgType == 1">
            <div class="col-sm-4">
              <div class="moduleHeading">Decision Reports</div>
              <div *ngFor="let ReportName of ReportData">
                <div *ngIf="ReportName.Link != ''">
                  <table class="tblModules">
                    <div *ngIf="ReportName.MainDescr == 'Decision Reports'">
                      <tr>
                        <td>
                          <div class="col-sm-2">
                            <img src="assets/resources/images/Report.png" class="imgicon" style="margin-right: 10px" />
                            &nbsp;&nbsp;
                          </div>
                          <div class="col-sm-10">
                            <a (click)="
                                OpenFlow(
                                  '85',
                                  ReportName.FlowID,
                                  ReportName.Link,
                                  '2',
                                  ReportName.SubDescr
                                )
                              ">
                              {{ ReportName.SubDescr }}
                            </a>
                          </div>
                        </td>
                      </tr>
                    </div>
                  </table>
                </div>
              </div>
            </div>
            <div class="col-sm-4">
              <div class="moduleHeading">Notice Reports</div>
              <div *ngFor="let ReportName of ReportData">
                <div *ngIf="ReportName.Link != ''">
                  <table class="tblModules">
                    <div *ngIf="ReportName.MainDescr == 'Notice Reports'">
                      <tr>
                        <td>
                          <div class="col-sm-2">
                            <img src="assets/resources/images/Report.png" class="imgicon" style="margin-right: 10px" />
                            &nbsp;&nbsp;
                          </div>
                          <div class="col-sm-10">
                            <a (click)="
                                OpenFlow(
                                  '85',
                                  ReportName.FlowID,
                                  ReportName.Link,
                                  '3',
                                  ReportName.SubDescr
                                )
                              ">
                              {{ ReportName.SubDescr }}
                            </a>
                          </div>
                        </td>
                      </tr>
                    </div>
                  </table>
                </div>
              </div>
            </div>
            <div class="col-sm-4">
              <div class="moduleHeading">Case Reports</div>
              <div *ngFor="let ReportName of ReportData">
                <div *ngIf="ReportName.Link != ''">
                  <table class="tblModules">
                    <div *ngIf="ReportName.MainDescr == 'Case Reports'">
                      <tr>
                        <td>
                          <div class="col-sm-2">
                            <img src="assets/resources/images/Report.png" class="imgicon" style="margin-right: 10px" />
                          </div>
                          <div class="col-sm-10">
                            <a (click)="
                                OpenFlow(
                                  '85',
                                  ReportName.FlowID,
                                  ReportName.Link,
                                  '4',
                                  ReportName.SubDescr
                                )
                              ">
                              {{ ReportName.SubDescr }}
                            </a>
                          </div>
                        </td>
                      </tr>
                    </div>
                  </table>
                </div>
              </div>
            </div>
          </div>
          <div *ngIf="this.MsgType == 0">
            <div [innerHtml]="ModuleData"></div>
          </div>
          <div *ngIf="this.MsgType == 6">
            <div class="col-sm-6" [innerHtml]="ModuleData"></div>
            <div class="col-sm-6">
              <div class="moduleHeading">Reports<br />&nbsp;</div>
              <div *ngFor="let ReportName of ReportData">
                <div *ngIf="ReportName.Link != ''">
                  <table class="tblModules">
                    <div *ngIf="ReportName.MainDescr == 'Report'">
                      <div class="col-sm-2">
                        <img src="assets/resources/images/Report.png" class="imgicon" style="margin-right: 10px" />
                        &nbsp;&nbsp;
                      </div>
                      <div class="col-sm-10">
                        <a (click)="
                            OpenFlow(
                              '85',
                              ReportName.FlowID,
                              ReportName.Link,
                              '7',
                              ReportName.SubDescr
                            )
                          ">
                          {{ ReportName.SubDescr }}
                        </a>
                      </div>
                    </div>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- modal-Module-End -->
  <!-- modal-dialog-for Iframe-Start -->
  <div id="ModalPopUPIFrame" class="modal fade" data-backdrop="static" data-keyboard="false" role="dialog">
    <div class="modal-dialog-FactSheet">
      <div class="modal-content">
        <div class="modal-header BlueHeader">
          <h4 class="Heading">{{ ModelFor }}</h4>
          <br />
          <button type="button" class="close" (click)="this[CallFunctionOnCloseModal]()" data-dismiss="modal">
            &times;
          </button>
        </div>
        <div class="modal-body col-sm-12 form-group">
          <iframe width="100%" Height="340 px" frameBorder="0" [src]="modalURL | safe"></iframe>
        </div>
      </div>
    </div>
  </div>
  <!-- modal-dialog-for Iframe-End -->

  <!-- <div class="container-scroller"> -->

  <!-- partial -->
  <!-- <div class="container-fluid page-body-wrapper"> -->
  <!-- partial:partials/_sidebar.html -->

  <!-- partial -->
  <div class="content-wrapper position-relative" style="height: calc(100vh - 70px)">
    <div class="row">
      <div class="col-md-6 grid-margin stretch-card">
        <div class="card">
          <div class="card-body performane-indicator-card">
            <!-- <div class="d-sm-flex"> -->
              <!-- <h4 class="card-title flex-shrink-1">Case</h4> -->
              <!-- <p class="m-sm-0 ms-sm-auto flex-shrink-0">
                <span class="data-time-range ms-0">7d</span>
                <span class="data-time-range active">2w</span>
                <span class="data-time-range">1m</span>
                <span class="data-time-range">3m</span>
                <span class="data-time-range">6m</span>
              </p> -->
            <!-- </div> -->
            <!-- <div class="d-sm-flex flex-wrap mt-3">
              <div class="d-flex align-items-center">
                <span class="dot-indicator bg-primary ms-2"></span>
                <p class="mb-0 ms-2 text-muted font-weight-semibold">
                  Complaints (2098)
                </p>
              </div>
              <div class="d-flex align-items-center">
                <span class="dot-indicator bg-info ms-2"></span>
                <p class="mb-0 ms-2 text-muted font-weight-semibold">
                  Task Done (1123)
                </p>
              </div>
              <div class="d-flex align-items-center">
                <span class="dot-indicator bg-danger ms-2"></span>
                <p class="mb-0 ms-2 text-muted font-weight-semibold">
                  Attends (876)
                </p>
              </div>
            </div> -->
            <div style="height: 40vh !important;">
              <!-- <canvas baseChart [datasets]="barChartData" [labels]="barChartLabels" [options]="barChartOptions"
                [legend]="barChartLegend" [type]="'bar'" (chartClick)="onChartClick($event)" >
              </canvas> -->
              @if (monthlyCases?.length > 0) {
                <canvas
                  baseChart 
                  [data]="chartData" 
                  [options]="chartOptions"
                  [type]="'bar'">
                </canvas>
              } @else {
               <div class="error-wrapper info">
                  <i class="fas fa-info-circle"></i>
                  <span>No data found.</span>
                </div>
              }
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6 grid-margin stretch-card">
        <div class="card">
          <div class="card-body">
            <!-- <h4 class="card-title">Notice</h4> -->
            <div style="height: 40vh !important;" class="aligner-wrapper">
              <!-- <div class="doughnut-chart-height">
                <canvas baseChart [type]="'line'" [data]="dueTrendData" [options]="dueTrendOptions"  (chartClick)="onCaseChartClick($event)" >
                </canvas>
              </div> -->
                <!-- <canvas
                  baseChart
                  [data]="noticeChartData"
                  [options]="noticeChartOptions"
                  [type]="'bar'">
                </canvas> -->
                @if (monthlyPendingNotice?.length > 0) {
                  <canvas
                    baseChart
                    [data]="noticeChartData" 
                    [options]="noticeChartOptions"
                    [type]="'line'">
                  </canvas>
                } @else {
                  <div class="error-wrapper info">
                    <i class="fas fa-info-circle"></i>
                    <span>No data found.</span>
                  </div>
                }

            </div>
            <!-- <div class="wrapper mt-5 d-flex flex-wrap align-items-cente">
              <div class="d-flex">
                <span class="square-indicator bg-danger ms-2"></span>
                <p class="mb-0 ms-2">Assigned</p>
              </div>
              <div class="d-flex">
                <span class="square-indicator bg-success ms-2"></span>
                <p class="mb-0 ms-2">Not Assigned</p>
              </div>
              <div class="d-flex">
                <span class="square-indicator bg-warning ms-2"></span>
                <p class="mb-0 ms-2">Reassigned</p>
              </div>
            </div> -->
          </div>
        </div>
      </div>
      <!-- <div class="col-md-6">
				 <div class="chart-container">
          <div id="managerMonthlyCasesChart" class="canvasjs-chart"></div>
        </div>
      </div> -->
    </div>
    <!-- Quick Action Toolbar Starts-->
    <!-- <div class="row quick-action-toolbar">
          <div class="col-md-12 grid-margin">
            <div class="card">
              <div class="card-header d-block d-md-flex">
                <h5 class="mb-0">Quick Actions</h5>
                <p class="ms-auto mb-0">
                  How are your active users trending overtime?<i
                    class="icon-bulb"
                  ></i>
                </p>
              </div>
              <div
                class="d-md-flex row m-0 quick-action-btns"
                role="group"
                aria-label="Quick action buttons"
              >
                <div class="col-sm-6 col-md-2 p-3 text-center btn-wrapper">
                  <button type="button" class="btn px-0">
                    <i class="icon-user me-2"></i> Decision
                  </button>
                </div>
                <div class="col-sm-6 col-md-2 p-3 text-center btn-wrapper">
                  <button type="button" class="btn px-0">
                    <i class="icon-docs me-2"></i> Notice
                  </button>
                </div>
                <div class="col-sm-6 col-md-2 p-3 text-center btn-wrapper">
                  <button type="button" class="btn px-0">
                    <i class="icon-folder me-2"></i> Case
                  </button>
                </div>
                <div class="col-sm-6 col-md-2 p-3 text-center btn-wrapper">
                  <button type="button" class="btn px-0">
                    <i class="icon-book-open me-2"></i>Final Verdict
                  </button>
                </div>
                <div class="col-sm-6 col-md-2 p-3 text-center btn-wrapper">
                  <button type="button" class="btn px-0">
                    <i class="icon-docs me-2"></i> Diary
                  </button>
                </div>
                <div class="col-sm-6 col-md-2 p-3 text-center btn-wrapper">
                  <button type="button" class="btn px-0">
                    <i class="icon-folder me-2"></i> Senior Feedback
                  </button>
                </div>
                <div class="col-sm-6 col-md-2 p-3 text-center btn-wrapper">
                  <button type="button" class="btn px-0">
                    <i class="icon-book-open me-2"></i>My Feedback
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div> -->
    <div class="row quick-action-toolbar">
      <div class="col-md-12 grid-margin">
        <div class="card">
          <div class="card-header d-block d-md-flex">
            <h5 class="mb-0">Quick Actions</h5>
            <!-- <p class="ms-auto mb-0">
                  How are your active users trending overtime?<i
                    class="icon-bulb"
                  ></i>
                </p> -->
          </div>

          <div class="quick-action-btns" role="group" aria-label="Quick action buttons">
            <div class="btn-wrapper">
              <a class="btn" routerLink="/report/207046000/0/2/0/0/0" target="_blank" >
                <i class="icon-user me-2"></i> Decision
              </a>
            </div>
            <div class="btn-wrapper">
              <a class="btn" routerLink="/report/207052000/0/2/0/0/0" target="_blank">
                <i class="icon-docs me-2"></i> Notice
              </a>
            </div>
            <div class="btn-wrapper">
              <a class="btn" routerLink="/report/207054000/0/2/0/0/0" target="_blank">
                <i class="icon-folder me-2"></i> Case
              </a>
            </div>
            <div class="btn-wrapper">
              <a class="btn" routerLink="/report/207074000/0/2/0/0/0" target="_blank">
                <i class="icon-book-open me-2"></i> Final Verdict
              </a>
            </div>
            <div class="btn-wrapper">
              <a type="button" class="btn" routerLink="/report/207048000/0/0/0/0/0" target="_blank">
                <i class="icon-docs me-2"></i> Senior feedback
              </a>
            </div>
            <div class="btn-wrapper">
              <a type="button" class="btn" routerLink="/Ecode" target="_blank">
                <i class="icon-folder me-2"></i> E-court Intigration
              </a>
            </div>
            <div class="btn-wrapper">
              <a type="button" class="btn" routerLink="/emaillog" target="_blank">
                <i class="icon-book-open me-2"></i> Email log
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Quick Action Toolbar Ends-->
    <div class="row">
      <div class="col-md-12 grid-margin">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-12">
                <div class="d-sm-flex align-items-baseline report-summary-header">
                  <h5 class="font-weight-semibold">Action</h5>
                  <span class="ms-auto">Updated Report</span>
                  <button class="btn btn-icons border-0 p-2">
                    <i class="icon-refresh"></i>
                  </button>
                </div>
              </div>
            </div>
            <div class="row report-inner-cards-wrapper">
              <div class="col-md -6 col-xl report-inner-card">
                <div class="inner-card-text">
                  <a href="/viewdiary">
                    <span class="report-title">VIEW DIARY</span>
                  </a>
                  <!-- <h4>$32123</h4>
                      <span class="report-count"> 2 Reports</span> -->
                </div>
                <div class="inner-card-icon bg-success">
                  <i class="icon-rocket"></i>
                </div>
              </div>
              <div class="col-md-6 col-xl report-inner-card">
                <div class="inner-card-text">
                  <a href="/viewexpense">
                    <span class="report-title">VIEW EXPENSE</span>
                  </a>
                  <!-- <h4>95,458</h4>
                      <span class="report-count"> 3 Reports</span> -->
                </div>
                <div class="inner-card-icon bg-danger">
                  <i class="icon-briefcase"></i>
                </div>
              </div>
              <!-- <div class="col-md-6 col-xl report-inner-card">
                <div class="inner-card-text">
                  <a href="#" data-toggle="modal" (click)="
            OpenModalIFrame('addlibrary', '0', 'fetchLibrary', 'Create Library')
          " data-target="#ModalPopUPIFrame">
                    <span class="report-title">UPLOAD LIBRARY</span>
                  </a>
                </div>
                <div class="inner-card-icon bg-warning">
                  <i class="icon-globe-alt"></i>
                </div>
              </div> -->
              <div class="col-md-6 col-xl report-inner-card">
                <div class="inner-card-text">
                  <a routerLink="{{ RouteLibraryEdit }}">
                    <span class="report-title">VIEW LIBRARY</span>
                  </a>
                </div>
                <div class="inner-card-icon bg-primary">
                  <i class="icon-diamond"></i>
                </div>
              </div>
              <div class="col-md-6 col-xl report-inner-card">
                <div class="inner-card-text">
                  <a routerLink="{{ RouteOrgEdit }}">
                    <span class="report-title">View Organization</span>
                  </a>
                </div>
                <div class="inner-card-icon bg-primary">
                  <i class="icon-globe-alt"></i>
                </div>
              </div>
              <div class="col-md-6 col-xl report-inner-card">
                <div class="inner-card-text">
                  <span class="report-title">IMPORT</span>
                </div>
                <div class="inner-card-icon bg-primary">
                  <i class="icon-cloud-upload"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="row">
      <div class="col-md-12 grid-margin stretch-card">
        <div class="card">
          <div class="card-body">
            <div class="d-sm-flex align-items-center mb-4">
              <h4 class="card-title mb-sm-0">Notice / Case Summary</h4>
              <a href="#" class="text-dark ms-auto mb-3 mb-sm-0">
                View all Products</a
              >
            </div>
            <div class="table-responsive border rounded p-1">
              <table class="table">
                <thead>
                  <tr>
                    <th class="font-weight-bold">Store ID</th>
                    <th class="font-weight-bold">Amount</th>
                    <th class="font-weight-bold">Gateway</th>
                    <th class="font-weight-bold">Created at</th>
                    <th class="font-weight-bold">Paid at</th>
                    <th class="font-weight-bold">Status</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <img
                        class="img-sm rounded-circle"
                        src="assets/images/faces/face1.jpg"
                        alt="profile image"
                      />
                      Katie Holmes
                    </td>
                    <td>$3621</td>
                    <td>
                      <img
                        src="assets/images/dashboard/alipay.png"
                        alt="alipay"
                        class="gateway-icon me-2"
                      />
                      alipay
                    </td>
                    <td>04 Jun 2019</td>
                    <td>18 Jul 2019</td>
                    <td>
                      <div class="badge badge-success p-2">Paid</div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <img
                        class="img-sm rounded-circle"
                        src="assets/images/faces/face2.jpg"
                        alt="profile image"
                      />
                      Minnie Copeland
                    </td>
                    <td>$6245</td>
                    <td>
                      <img
                        src="assets/images/dashboard/paypal.png"
                        alt="alipay"
                        class="gateway-icon me-2"
                      />
                      Paypal
                    </td>
                    <td>25 Sep 2019</td>
                    <td>07 Oct 2019</td>
                    <td>
                      <div class="badge badge-danger p-2">Pending</div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <img
                        class="img-sm rounded-circle"
                        src="assets/images/faces/face3.jpg"
                        alt="profile image"
                      />
                      Rodney Sims
                    </td>
                    <td>$9265</td>
                    <td>
                      <img
                        src="assets/images/dashboard/alipay.png"
                        alt="alipay"
                        class="gateway-icon me-2"
                      />
                      alipay
                    </td>
                    <td>12 dec 2019</td>
                    <td>26 Aug 2019</td>
                    <td>
                      <div class="badge badge-warning p-2">Failed</div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <img
                        class="img-sm rounded-circle"
                        src="assets/images/faces/face4.jpg"
                        alt="profile image"
                      />
                      Carolyn Barker
                    </td>
                    <td>$2263</td>
                    <td>
                      <img
                        src="assets/images/dashboard/alipay.png"
                        alt="alipay"
                        class="gateway-icon me-2"
                      />
                      alipay
                    </td>
                    <td>30 Sep 2019</td>
                    <td>20 Oct 2019</td>
                    <td>
                      <div class="badge badge-success p-2">Paid</div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="d-flex mt-4 flex-wrap align-items-center">
              <p class="text-muted mb-sm-0">Showing 1 to 10 of 57 entries</p>
              <nav class="ms-auto">
                <ul class="pagination separated pagination-info mb-sm-0">
                  <li class="page-item">
                    <a href="#" class="page-link"
                      ><i class="icon-arrow-left"></i
                    ></a>
                  </li>
                  <li class="page-item active">
                    <a href="#" class="page-link">1</a>
                  </li>
                  <li class="page-item">
                    <a href="#" class="page-link">2</a>
                  </li>
                  <li class="page-item">
                    <a href="#" class="page-link">3</a>
                  </li>
                  <li class="page-item">
                    <a href="#" class="page-link">4</a>
                  </li>
                  <li class="page-item">
                    <a href="#" class="page-link"
                      ><i class="icon-arrow-right"></i
                    ></a>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </div> -->
    <footer class="footer position-absolute w-100" style="bottom: 0px;">
      <div class="d-sm-flex justify-content-center justify-content-sm-between">
        <span class="text-muted text-center text-sm-left d-block d-sm-inline-block">Copyright © 2024-25 Redleaf Legal
          Management. All rights reserved.
          <a href="https://redleafsoftwares.com/welcome/contact" target="_blank"> Terms of use</a>
          <a href="https://redleafsoftwares.com/welcome/contact" target="_blank">Privacy Policy</a></span>
        <span class="float-none float-sm-right d-block mt-1 mt-sm-0 text-center">Maintained by-
          <a style="color: #005da0 !important" href="https://redleafsoftwares.com" target="_blank">RedLeaf Softwares &
            Services LLP
          </a>
        </span>
      </div>
    </footer>
  </div>
  <!-- content-wrapper ends -->
  <!-- partial:partials/_footer.html -->
  <!-- partial -->
  <!-- main-panel ends -->
  <!-- </div> -->
  <!-- page-body-wrapper ends -->
  <!-- </div> -->
</my-content>
<!-- <my-content placeholder="main">
    &nbsp;

</my-content> -->